<template>
    <div>
        <h5>Manage Users</h5>
        <div>
            <Toolbar class="mb-4 card">
                <template v-slot:end>
                    <div class="flex">
                        <div v-if="authStore.hasPermission(UserPermission.WRITE_USERS)" class="my-2">
                            <Button label="Add New User" class="mr-2" icon="pi pi-plus" @click="userFormDialog = true" />
                        </div>
                    </div>
                </template>
            </Toolbar>
            <!-- users table -->
            <UsersTable />
            <!-- create users form here -->
            <Dialog v-model:visible="userFormDialog" :style="{ width: '450px' }" header="Add New User" :modal="true" class="p-fluid dialog-header">
                <!-- Dialog form section starts -->
                <UserForm @close-dialog="userFormDialog = false" />
                <!-- Dialog form section ends -->
            </Dialog>
        </div>
    </div>
</template>

<script setup>
import UsersTable from '../components/UsersTable.vue';
import UserForm from '../components/UserForm.vue';

import { ref } from 'vue';
import { authStore } from '../../../store/global-stores';
import { UserPermission } from '../../permission/enum';

const userFormDialog = ref(false);
</script>
